




























































import { Vue, Component, Ref } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form.d';
import TimerButton from '@/TimerButton';
import { updatePasswordByPhone } from 'service/api';

@Component({
  components: {
    TimerButton,
  },
})
export default class Password extends Vue {
  @Ref('passwordForm') readonly passwordForm!: ElForm;

  userInput = {
    phone: '',
    code: '',
    password: '',
    passwordAgain: '',
  };

  rules = {
    phone: [
      {
        required: true,
        pattern: /^1[3456789]\d{9}$/,
        message: '请输入正确的手机号',
        trigger: 'blur',
      },
    ],
    code: [
      { required: true, message: '请输入验证码', trigger: 'blur' },
    ],
    password: [
      {
        required: true,
        message: '请输入密码',
      },
    ],
    passwordAgain: [
      { validator: this.validatePasswordAgain },
    ],
  };

  isValidating = false;

  validatePasswordAgain(rule: object, value: string, callback: (err: Error|void) => void) {
    if (value === '') {
      callback(new Error('请再次输入密码'));
    } else if (value !== this.userInput.password) {
      callback(new Error('两次输入的密码不一致'));
    } else {
      callback();
    }
  }

  update() {
    this.isValidating = true;
    this.passwordForm.validate((valid) => {
      if (valid) {
        updatePasswordByPhone({
          phonenumber: this.userInput.phone,
          password: this.userInput.password,
          singleSendercode: this.userInput.code,
          codeType: 2,
        })
          .then((res) => {
            if ((res as { code: number; message: string }).code === 1) {
              this.$message.success('修改密码成功');
              this.$router.push({ name: 'login', params: { phone: this.userInput.phone } });
            } else {
              throw new Error((res as { code: number; message: string }).message);
            }
          })
          .catch((err = { message: '接口异常' }) => {
            this.$notify.error(err.message);
            this.isValidating = false;
          });
      } else {
        this.isValidating = false;
      }
    });
  }
}
